import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTracking } from '@PetSureAustralia/petsure-react-ui-library/distLib/hooks';
import { useFormContext } from 'react-hook-form';
import { HelpTopicSearchResultLabel } from './helpTopicsSearchResultLabel';
import { FaqsQuestionPropTypes } from '../../../propTypes/faqs';

export const HelpTopicsSearchResult = ({ result, clickHandler, autoCompleteField }) => {
  const { getValues } = useFormContext();

  const { id } = result;

  const resultButton = useRef(null);

  useTracking({
    elementRef: resultButton,
    trackingProps: {
      label: 'Help topic selection',
      field: {
        inputType: 'button'
      }
    }
  });

  const GetSearchTerm = () => {
    return getValues(autoCompleteField);
  };

  return (
    <button
      ref={resultButton}
      type="button"
      key={id}
      result={result}
      value={id}
      onClick={() => clickHandler({ result, inputValue: result })}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
      <HelpTopicSearchResultLabel
        topicDetail={result}
        highlightText={GetSearchTerm()}
      />
    </button>
  );
};

HelpTopicsSearchResult.propTypes = {
  result: FaqsQuestionPropTypes,
  clickHandler: PropTypes.func,
  autoCompleteField: PropTypes.string
};
